// auth.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SignInOutputData } from '../models/doctor-model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private idToken = new BehaviorSubject<string | null>(null);
  private accessToken = new BehaviorSubject<string | null>(null);
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  addHeader(): HttpHeaders {
    const token = sessionStorage.getItem('psicogeniusAccessToken');

    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  setIdToken(token: string) {
    this.idToken.next(token);
  }

  setAccessToken(token: string) {
    this.accessToken.next(token);
  }

  getIdToken() {
    return this.idToken.asObservable();
  }

  getAccessToken() {
    return this.accessToken.asObservable();
  }

  googleAuth(idToken: string): Observable<any> {
    return this.http.post('/api/auth/google-auth', { id_token: idToken });
  }

  getSignInOutputData(
    state: string,
    code: string
  ): Observable<SignInOutputData> {
    const endpoint = this.apiUrl + '/auth/google/callback';
    return this.http.get<SignInOutputData>(endpoint, {
      params: { state: state, code: code },
    });
  }

  refreshGoogleAccessToken(): Observable<any> {
    const headers = this.addHeader();
    const endpoint = this.apiUrl + '/auth/google/refresh-token';
    return this.http.get(endpoint, { headers });
  }

  refreshPsicogeniusAccessToken(): Observable<any> {
    const headers = this.addHeader();
    const endpoint = this.apiUrl + '/auth/refresh-token';
    return this.http.get(endpoint, { headers });
  }
}
